import {FormGroup} from '@sketchpixy/rubix';
import styled from 'styled-components';

export const StyledFormGroup = styled(FormGroup)`
  &.has-error {
    .control-label, .help-block, .checkbox, .checkbox-inline, .radio {
      color: red !important;
    }
    
    .form-control {
      border-color: red !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/routes/payment/FromStyle.js